<template>
  <div id="container">
    <div v-on:click="redirect()" class="register-button">
      <div id="left-circles">
        <div class="circle circle0"></div>
        <div class="circle circle1"></div>
        <div class="circle circle2"></div>
      </div>
      <p class="button-text">{{buttonText}}</p>
      <div id="right-circles">
        <div class="circle circle3"></div>
        <div class="circle circle4"></div>
        <div class="circle circle5"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["buttonText"],
  data() {
    return {};
  },
  methods: {
    redirect() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
#container {
  display: flex;
  justify-content: center;
}

.register-button {
  display: flex;
  align-items: center;
  background: #edf6fb;
  padding: 0px 5vw 0px 5vw;
  border-radius: calc(30px + (80 - 30) * ((100vw - 600px) / (3840 - 600)));
  transition: all 0.5s ease;
}

.register-button:hover {
  background: transparent;
  box-shadow: none;
  cursor: pointer;
}

.button-text {
  margin-top: 5%;
  margin-bottom: 0px !important;
  color: #0d2a4c;
  font-family: "Acumin Variable Concept";
  font-size: calc(35px + (80 - 35) * ((100vw - 600px) / (3840 - 600)));
  font-weight: bolder;
  text-align: center;
  text-shadow: 0.1vw 0.1vw 0.1vw rgba(16.1%, 19.6%, 32.9%, 0.5);
  .register-button:hover & {
    color: #edf6fb;
    text-shadow: none;
  }
}

// @-moz-document url-prefix() {
//   .button-text {
//     // margin-top: 5% !important; //comment this and see what happens
//   }
// }

#left-circles,
#right-circles {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle0,
.circle1,
.circle2,
.circle3,
.circle4,
.circle5 {
  position: absolute;
  border-radius: 50%;
  background: #edf6fb;
  transition: all 0.5s ease;
  opacity: 0;
  box-shadow: 0px 0px 0.3vw 0.3vw rgba(0, 0, 0, 0.1);
}

.circle0 {
  height: 2.2vw;
  width: 2.2vw;
  .register-button:hover & {
    opacity: 1;
    transform: translateX(-2vw);
  }
}

.circle1 {
  height: 1.8vw;
  width: 1.8vw;
  .register-button:hover & {
    opacity: 1;
    transform: translateX(-5vw);
  }
}

.circle2 {
  height: 1.3vw;
  width: 1.3vw;
  .register-button:hover & {
    opacity: 1;
    transform: translateX(-7.5vw);
  }
}

.circle3 {
  height: 2.2vw;
  width: 2.2vw;
  .register-button:hover & {
    opacity: 1;
    transform: translateX(2vw);
  }
}

.circle4 {
  height: 1.8vw;
  width: 1.8vw;
  .register-button:hover & {
    opacity: 1;
    transform: translateX(5vw);
  }
}

.circle5 {
  height: 1.3vw;
  width: 1.3vw;
  .register-button:hover & {
    opacity: 1;
    transform: translateX(7.5vw);
  }
}

@media screen and (max-width: 1024px) {
  .circle {
    .register-button:hover & {
      transform: none;
      opacity: 0;
    }
  }
  .register-button {
  padding: 0px 10vw 0px 10vw;
  }
}

</style>